import { handleFormatStyleString } from "../../../utils/common";
import { Footer1Props } from "./props";

import { FooterVariant01 } from "./variants/01";
import { FooterVariant02 } from "./variants/02";
import FooterVariant03 from "./variants/03";
import FooterVariant04 from "./variants/04";
import FooterVariant05 from "./variants/05";
import FooterPerfilClickVariant from "./variants/06";

export const Footer1 = (props: Footer1Props) => {
  const isPerfilClick = props.site?.subdomain?.includes("pc-") ?? false;
  //@ts-ignore
  if (props && (props.visible == false || props.visible?.value == false)) {
    return <div />;
  }

  const variant = Number(props?.variants?.value ?? 2);

  function renderFooter(): JSX.Element {
    switch (variant) {
      case 1:
        return <FooterVariant01 {...props} />;
      case 2:
        return <FooterVariant02 {...props} />;
      case 3:
        return <FooterVariant03 {...props} />;
      case 4:
        return <FooterVariant04 {...props} />;
      case 5:
        return <FooterVariant05 {...props} />;
      default:
        return <FooterVariant02 {...props} />;
    }
  }

  return (
    <>
      {props && props.styles && props.styles.value && (
        <style>
          {handleFormatStyleString(props.styles.value as string, props.id)}
        </style>
      )}

      {isPerfilClick ? <FooterPerfilClickVariant {...props} /> : renderFooter()}
    </>
  );
};
